module.exports = __webpack_public_path__ + "img/D201502_4.e40f06b1.jpg";